import { useQuery } from '@tanstack/react-query'
import { getSubscribers } from 'api'
import { UserResponse } from 'types/User'
import { auth } from 'utils/firebase'

interface Params {
  userId: string
}

const useFetchSubscribers = ({ userId }: Params) => {
  return useQuery<UserResponse[], Error>(['subscribers'], async () => {
    const token = await auth.currentUser?.getIdToken()
    if (userId && token) {
      return getSubscribers(userId)
    }
    return Promise.reject(new Error('Invalid token'))
  })
}

export default useFetchSubscribers
